/**
 * 应用配置文件
 * 修改 API 地址只需要修改这里即可
 */

// API 服务前缀（不带 /api/v1 后缀）
// 默认使用同源相对路径，避免写死域名/IP：
// - 生产环境通常由网关/Nginx 将 /short_video_api 反代到后端
// - 本地联调可通过 VUE_APP_API_HOST 覆盖为 http://x.x.x.x:port
export const API_HOST = process.env.VUE_APP_API_HOST || '/short_video_api'



// API 基础路径
export const API_BASE_URL = `${API_HOST}/api/v1`

// 静态资源地址
export const STATIC_URL = API_HOST

/** 广告片 ID（如 AD30709441）走 /ad/，与短视频 /videos/ 区分 */
export function isAdVideoId(id) {
  if (id == null || id === '') return false
  return String(id).startsWith('AD')
}

/** 种草视频 ID（如 PG30709441）走 /planting-video/ */
export function isPlantingVideoId(id) {
  if (id == null || id === '') return false
  return String(id).startsWith('PG')
}

// 获取视频流 URL（带权限验证）
export function getVideoStreamUrl(videoId, token = null) {
  if (!videoId) return ''
  let url = `${API_BASE_URL}/videos/${videoId}/stream`
  if (token) {
    url += `?token=${encodeURIComponent(token)}`
  }
  return url
}

// 广告片流 URL（/api/v1/ad/{ad_id}/stream）
export function getAdStreamUrl(adId, token = null) {
  if (!adId) return ''
  let url = `${API_BASE_URL}/ad/${adId}/stream`
  if (token) {
    url += `?token=${encodeURIComponent(token)}`
  }
  return url
}

export function getPlantingStreamUrl(plantingId, token = null) {
  if (!plantingId) return ''
  let url = `${API_BASE_URL}/planting-video/${plantingId}/stream`
  if (token) {
    url += `?token=${encodeURIComponent(token)}`
  }
  return url
}

export const config = {
  apiHost: API_HOST,
  apiBaseUrl: API_BASE_URL,
  staticUrl: STATIC_URL,
  maxVideoSize: 500 * 1024 * 1024,
  maxImageSize: 10 * 1024 * 1024,
  defaultPageSize: 20
}

export default config
